import styled from 'styled-components';

export const Link = styled.div`
  width: 100%;
  margin-top: 30px;
  color: var(--grey-7);
  font-size: 13px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const InputWrapper = styled.div`
  padding: 15px 0;
`;
